module.exports = __webpack_public_path__ + "images/screen-shots/daily_tracking-590f3e233c3065d5341083c1274ce576.png";